export const addNoAvailability = (name, date) => {
  dataLayer.push({
    Category: 'Müsaitlik Yok',
    Action: date, // "Check-in Date" - "Check-out Date"
    Label: name, // "Ürün Adı"
    noninteraction: true,
    event: 'gaEvent',
  });
};
